@if (!guestRole) {
  <div class="header-container">
    <h3>Guest Accounts</h3>
    <button mat-raised-button routerLink="create" color="primary" style="margin-right:0">Assign new role</button>
  </div>
  <app-guest-table [guests]="guestRoles" [includeSearch]="true" [hidden]="loading || !guestRoles"></app-guest-table>
  @if (loading) {
    <app-loading></app-loading>
  }
}